import { AfterViewInit, Component } from '@angular/core';
import { PunchoutAuditOutcome } from '../../../../models/punchout';
import { punchoutAuditOutcomeBadgeClass } from '../../../../utils/punchout-audit-utils';
import { PunchoutAuditTableBase } from '../punchout-audit-table.base';

/** Table layout for the cart transfers audit list. */
@Component({
  selector: 'lib-gung-settings-punchout-cart-transfers-table',
  templateUrl: './gung-settings-punchout-cart-transfers-table.component.html',
  styleUrl: './gung-settings-punchout-cart-transfers-table.component.scss',
  standalone: false
})
export class GungSettingsPunchoutCartTransfersTableComponent extends PunchoutAuditTableBase implements AfterViewInit {
  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  outcomeClass(outcome?: PunchoutAuditOutcome): string {
    return punchoutAuditOutcomeBadgeClass(outcome);
  }
}
